export const home = '/';
export const signIn = '/signin';
export const signUp = '/signup';
export const addProcess = '/add-process';
export const forgotPassword = '/forgotpassword';
export const resetPassword = '/resetpassword';
export const invite = '/invite';
